module.exports = __webpack_public_path__ + "static/media/3.ca931531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/3.jpg
// module id = 164
// module chunks = 0